import { css } from "styled-components";
import colors from "../../tokens/colors";

export const alertDialogVariables = css`
  --alert-overlay-opacity: 0.4;
  --alert-overlay-background-color: ${colors.primary.slateGrey};
`;
